<template>
  <v-container fluid>
    <v-layout row wrap>
      <v-flex class="d-flex justify-space-between mb-3 align-center" xs12>
        <h3 class="font-weight-bold">Trekking Revenue Report</h3>
        <div class="text-xs-right">
          <export-excel-button :export-data="exportData"
                               v-if="$oauth.checkIfHasPermission(['export trekking-revenue-report'])"></export-excel-button>
          <refresh-button :click-function="refreshData"></refresh-button>
        </div>
      </v-flex>

      <v-flex lg12>
        <v-card>
          <v-layout class="py-1 mx-2" row wrap>
            <v-flex xs3 class="pb-0">
              <v-text-field
                  class="hidden-sm-and-down"
                  flat
                  hide-details
                  placeholder="Search by typing here..."
                  prepend-inner-icon="search"
                  solo
                  v-model="filters.query"
                  @keypress.enter="fetchFiltersData"
              ></v-text-field>
            </v-flex>
            <v-flex xs3 class="d-flex align-center">
              <custom-date-range-picker @change="fetchFiltersData"  @input="fetchFiltersData"
                                        v-model="filters.date_range"></custom-date-range-picker>
            </v-flex>
            <v-flex xs3>
              <v-autocomplete
                  :items="agencies"
                  chips
                  clearable
                  deletable-chips
                  flat
                  hide-details
                  item-text="name"
                  item-value="id"
                  label="Filter By Agency"
                  multiple
                  prepend-inner-icon="filter_list"
                  solo
                  v-model="filters.agency_name"
                  @change="fetchFiltersData"
              ></v-autocomplete>
            </v-flex>
            <v-flex xs3>
              <v-autocomplete
                  :items="routes"
                  chips
                  clearable
                  deletable-chips
                  flat
                  hide-details
                  item-text="name"
                  item-value="id"
                  label="Filter By Route"
                  multiple
                  prepend-inner-icon="filter_list"
                  solo
                  v-model="filters.route"
                  @change="fetchFiltersData"
              ></v-autocomplete>
            </v-flex>
            <v-flex xs6>
              <v-autocomplete
                  :items="offices"
                  chips
                  clearable
                  deletable-chips
                  flat
                  hide-details
                  item-text="name"
                  item-value="id"
                  label="Filter By Office"
                  multiple
                  prepend-inner-icon="filter_list"
                  solo
                  v-model="filters.office"
                  @change="fetchFiltersData"
              ></v-autocomplete>
            </v-flex>

          </v-layout>

          <v-divider></v-divider>
          <v-card-text class="pa-0">
            <v-data-table
                :headers="headers"
                :items="data"
                :loading="loading"
                :options.sync="pagination"
                :footer-props="footerProps"
                class="elevation-0"
                v-if="$oauth.checkIfHasPermission(['read trekking-revenue-report'])">

              <template v-slot:item.total_cost="{ item }">
                {{'$ '+item.total_cost}}
              </template>
              <template v-slot:item.total_cost_npr="{ item }">
                {{item.total_cost_npr ? item.total_cost_npr : 0.00}}
              </template>
              <template v-slot:item.action="{ item }">
                <v-tooltip top v-if="$oauth.checkIfHasPermission('read read trekking-request')">
                  <template v-slot:activator="{ on }">
                    <v-btn
                        class="mr-2"
                        color="primary"
                        dark
                        dense
                        fab
                        v-on="on"
                        :href="'/system/trekking-requests/view/'+item.id"
                        :to="'/system/trekking-requests/view/'+item.id"
                        x-small>
                      <v-icon small>mdi-eye</v-icon>
                    </v-btn>
                  </template>
                  <span>View Trekking Request</span>
                </v-tooltip>
              </template>
            </v-data-table>
            <issued-visa-footer @nextClick="handleNextClick" @prevClick="handlePrevClick"
                                :disable-next="disableNext"
                                :disable-prev="disablePrev"
                                :perPage="pagination.itemsPerPage"
                                @rowChanged="fetchDataWithRow"
                                @getCount="getCount"
                                :total="total"
                                :items-loading="totalItemsLoading"
                                :showing-of="showingOf"
            />
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
import {mapActions, mapMutations, mapGetters} from 'vuex';
import CustomDateRangePicker from "../../components/CustomDateRangePicker";
import {commonStoreMixin} from "../../mixins/commonStoreMixin";
import IssuedVisaFooter from "../../components/footer/IssuedVisaFooter";
import ExportExcelButton from "../../components/ExportExcelButton";
import RefreshButton from "@/components/RefreshButton";


export default {
  data() {
    return {
      title: "Trekkers Report",
      pagination: {
        itemsPerPage: 25,
        sortBy: ["created_at"],
        sortDesc: ["true"]
      },
      headers: [
        {
          text: "S.N.",
          value: "s_no",
          sortable: true
        },
        {
          text: "Submission No.",
          value: "submission_no",
          sortable: false
        },
        {
          text: "Office",
          value: "office_name",
          sortable: false
        },
        {
          text: "Trekking Agency",
          value: "agency_name",
          sortable: false
        },

        {
          text: "Trekking Route",
          value: "trekking_route",
          sortable: false
        },
        {
          text: "Trekking No Of Days",
          value: "no_of_days",
          sortable: false
        },
        {
          text: "Trekking Cost (USD)",
          value: "total_cost",
          sortable: false
        },
        {
          text: "No of Trekkers",
          value: "trekkers_no",
          sortable: false
        },
        {
          text: "Trekking Cost (NPR)",
          value: "total_cost_npr",
          sortable: false
        },
        {
          text: "Voucher/Invoice Number",
          value: "invoice_number",
          sortable: false
        },
        {
          text: "Source",
          value: "source",
          sortable: false
        },
        {
          text: "Created Date",
          value: "created_at",
          sortable: true
        },
        {
          text: "Action",
          value: "action",
          sortable: false
        }
      ],
    };
  },
  components: {RefreshButton, CustomDateRangePicker, IssuedVisaFooter, ExportExcelButton},
  mixins: [commonStoreMixin],
  computed: {
    ...mapGetters({
      loading: "TrekkingRevenueReport/reportLoading",
      agencies: "TrekkingSingle/trekkingAgencylist",
      countries: "CountryList/all",
      routes: "TrekkingSingle/trekkingRouteslist",
      offices: "OfficeList/offices"
    }),
  },
  methods: {
    view(item) {
      this.$router.push({
        name: "TravellerDetail",
        params: {id: item.traveller.toString()}
      });
    },
    refreshData(){
      this.fetchData();
    },
  },

  mounted() {
    this.stateName = 'TrekkingRevenueReport';
    this.commonState = this.$store.state.TrekkingRevenueReport;
    this.$store.dispatch('TrekkingSingle/getTrekkingAgencyList');
    this.$store.dispatch('TrekkingSingle/getAllTrekkingRoutesList');
    this.$store.dispatch('OfficeList/fetchAll');
    // this.fetchData()
  }
};
</script>
